// import API_Root from '../Constants/API_Root';
import API_Root from '../Constants/API_Root';



export const refreshAccessToken = async () => {
    const refreshToken = localStorage.getItem("refresh_token");
  
    if (!refreshToken) {
      throw new Error("No refresh token found");
    }
  
    const response = await fetch(
      `${API_Root}auth/create-refresh-token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          refresh_token: refreshToken,
        }),
      }
    );
  
    if (!response.ok) {
      throw new Error("Failed to refresh token");
    }
  
    const data = await response.json();
  
    localStorage.setItem("access_token", data.access_token);
  
    return data.access_token;
  };


  export const authFetch = async (url, options = {}) => {
    let accessToken = localStorage.getItem("token");
  
    let response = await fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${accessToken}`,
      },
    });
  
    if (response.status === 401) {
      try {
        accessToken = await refreshAccessToken();
  
        response = await fetch(url, {
          ...options,
          headers: {
            ...options.headers,
            Authorization: `Bearer ${accessToken}`,
          },
        });
      } catch (error) {
        localStorage.clear();
        window.location.href = "/login";
        throw error;
      }
    }
  
    return response;
  };